// extracted by css-extract-rspack-plugin
export default {"messageHeader":"messageHeader-s76IKy"};